export default "__VITE_ASSET__2d234241__"